const vaccinationSchema = ({ data, headers }) => {
  const status = data.appointment_status
  return (
    <tr className='text-gray-600'>
      {headers.map((key) => {
        switch (key.toUpperCase()) {
          case 'EMPLOYEE ID':
            return <td className='pl-3 pr-5 py-5'>{data.employee_id}</td>

          case 'EMPLOYEE DETAILS':
            return (
              <td className='pl-3 pr-5 py-5 '>
                <p className='font-semibold mb-0 inline-block mr-2'>{data.employee_details.name}</p>
                {data.employee_details.active && <span className='px-2 inline-flex leading-6 font-semibold rounded-full bg-green-100 text-green-700'>Active</span>}
                <p className='mb-0'>{data.employee_details.email}</p>
              </td>
            )
          case 'CUSTOMER TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.customer_type}</span>
              </td>
            )

          case 'APPOINTMENT DATE & ID':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.appointment_date_id.timestamp}</span>
                <br />
                <span>{data.appointment_date_id.apt_id}</span>
              </td>
            )
          case 'PROVIDER':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.diagnostic_center.provider_name}</span>
                <br />
                <span>{data.diagnostic_center.area}</span>
              </td>
            )

          case 'APPOINTMENT STATUS':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span className='px-2 inline-flex leading-7 font-semibold rounded-full bg-green-100 text-green-700'>{status === 'received' ? 'completed' : status}</span>
              </td>
            )
          case 'VACCINATION NAME & AMOUNT':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.vaccination_name_amount.name}</span>
                <br />
                <span>&#8377;{data.vaccination_name_amount.amount} </span>
              </td>
            )

          case 'PACKAGE TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.package_type}</span>
              </td>
            )

          case 'DATE OF BIRTH':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.date_of_birth}</span>
              </td>
            )

          case 'GENDER':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.gender}</span>
              </td>
            )

          case 'RELATION':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.relation}</span>
              </td>
            )

          // case 'SPONSOR DEPARTMENT':
          //   return (
          //     <td className='pl-3 pr-5 py-5'>
          //       <span>{data.sponsor_department}</span>
          //     </td>
          //   );

          case 'ENTITY':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.entity}</span>
              </td>
            )

          // case 'PHONE':
          //   return (
          //     <td className='pl-3 pr-5 py-5'>
          //       <span>{data.mobile_number}</span>
          //     </td>
          //   );
        }
      })}
    </tr>
  )
}

export default vaccinationSchema